// extracted by mini-css-extract-plugin
export var container = "IndividualSetStatistics-module--container--e2949";
export var statistics = "IndividualSetStatistics-module--statistics--3b1fd";